var _path, _path2, _path3, _path4, _g, _path5, _path6, _path7, _path8, _path9, _path10, _path11, _path12, _path13, _path14, _g2, _path15, _path16, _path17, _path18, _path19, _path20, _g3, _path21, _g4, _path22, _path23, _path24, _path25, _path26, _path27, _g5, _path28, _path29, _g6;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgConfigureLivechat(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 458,
    height: 240,
    viewBox: "0 0 458 240",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M239 21.5154C336.202 21.5154 415 100.313 415 197.515C415 211.275 413.421 224.666 410.434 237.517H67.5664C64.5794 224.666 63.0004 211.275 63.0004 197.515C63.0004 100.313 141.798 21.5154 239 21.5154Z",
    fill: "#EFF5FD"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M3 237.5H442M449.809 237.8H455.907",
    stroke: "#747678",
    strokeWidth: 2.5,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    d: "M42 92.5H236C241.523 92.5 246 96.977 246 102.5V237.5H32V102.5C32 96.977 36.477 92.5 42 92.5Z",
    fill: "white"
  })), /*#__PURE__*/React.createElement("mask", {
    id: "mask0_360_148",
    style: {
      maskType: "luminance"
    },
    maskUnits: "userSpaceOnUse",
    x: 212,
    y: 76,
    width: 118,
    height: 146
  }, _path4 || (_path4 = /*#__PURE__*/React.createElement("path", {
    d: "M212 76H330V222H212V76Z",
    fill: "white"
  }))), _g || (_g = /*#__PURE__*/React.createElement("g", {
    mask: "url(#mask0_360_148)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M247 76.446H325C327.761 76.446 330 78.685 330 81.446V216.446C330 219.207 327.761 221.446 325 221.446H247V76.446Z",
    fill: "#CEDFF8"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M212 104.446V81.446C212 78.685 214.239 76.446 217 76.446H247V221.446H217C214.239 221.446 212 219.207 212 216.446V207.446",
    fill: "#EEEEEE"
  }))), _path5 || (_path5 = /*#__PURE__*/React.createElement("path", {
    d: "M238 164.446V207.446H180V164.446H238Z",
    fill: "#EEEEEE"
  })), _path6 || (_path6 = /*#__PURE__*/React.createElement("path", {
    d: "M245.875 137.392L32 137.446V104.446L245.875 104.392",
    fill: "#EEEEEE"
  })), _path7 || (_path7 = /*#__PURE__*/React.createElement("path", {
    d: "M96 164.446V207.446H38V164.446H96Z",
    fill: "#EEEEEE"
  })), _path8 || (_path8 = /*#__PURE__*/React.createElement("path", {
    d: "M167 164.446V207.446H109V164.446H167Z",
    fill: "#EEEEEE"
  })), _path9 || (_path9 = /*#__PURE__*/React.createElement("path", {
    d: "M100 148.446C101.105 148.446 102 149.341 102 150.446C102 151.551 101.105 152.446 100 152.446H41C39.895 152.446 39 151.551 39 150.446C39 149.341 39.895 148.446 41 148.446H100Z",
    fill: "#EEEEEE"
  })), _path10 || (_path10 = /*#__PURE__*/React.createElement("path", {
    d: "M212 164.446H238V207.446H212V164.446Z",
    fill: "#CBCCCD"
  })), _path11 || (_path11 = /*#__PURE__*/React.createElement("path", {
    d: "M41 115.446H100C101.105 115.446 102 116.341 102 117.446V124.446C102 125.551 101.105 126.446 100 126.446H41C39.895 126.446 39 125.551 39 124.446V117.446C39 116.341 39.895 115.446 41 115.446Z",
    fill: "white"
  })), _path12 || (_path12 = /*#__PURE__*/React.createElement("path", {
    d: "M40 94.4458H238C242.418 94.4458 246 98.0278 246 102.446V107.446H134.592H32V102.446C32 98.0278 35.582 94.4458 40 94.4458Z",
    fill: "#747678"
  })), _path13 || (_path13 = /*#__PURE__*/React.createElement("path", {
    d: "M42 93.5168H236C241.523 93.5168 246 97.9938 246 103.517V237.517H32V103.517C32 97.9938 36.477 93.5168 42 93.5168Z",
    stroke: "#747678",
    strokeWidth: 2.5,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), /*#__PURE__*/React.createElement("mask", {
    id: "mask1_360_148",
    style: {
      maskType: "luminance"
    },
    maskUnits: "userSpaceOnUse",
    x: 200,
    y: 52,
    width: 114,
    height: 148
  }, _path14 || (_path14 = /*#__PURE__*/React.createElement("path", {
    d: "M200 52H314V200H200V52Z",
    fill: "white"
  }))), _g2 || (_g2 = /*#__PURE__*/React.createElement("g", {
    mask: "url(#mask1_360_148)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M207 54H307C309.761 54 312 56.239 312 59V193C312 195.761 309.761 198 307 198H207C204.239 198 202 195.761 202 193V59C202 56.239 204.239 54 207 54Z",
    fill: "white"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M207 54H307C309.761 54 312 56.239 312 59V193C312 195.761 309.761 198 307 198H207C204.239 198 202 195.761 202 193V59C202 56.239 204.239 54 207 54Z",
    stroke: "#317AE2",
    strokeWidth: 2.5,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M207 54H307C309.761 54 312 56.239 312 59V73H202V59C202 56.239 204.239 54 207 54Z",
    fill: "#317AE2"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M212 170H304C305.105 170 306 170.895 306 172V190C306 191.105 305.105 192 304 192H212C210.895 192 210 191.105 210 190V172C210 170.895 210.895 170 212 170Z",
    fill: "#CEDFF8"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M249 149C251.209 149 253 150.791 253 153C253 155.209 251.209 157 249 157H214C211.791 157 210 155.209 210 153C210 150.791 211.791 149 214 149H249Z",
    fill: "#DCDDDD"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M249 115C251.209 115 253 116.791 253 119C253 121.209 251.209 123 249 123H214C211.791 123 210 121.209 210 119C210 116.791 211.791 115 214 115H249Z",
    fill: "#DCDDDD"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M302 99C304.209 99 306 100.791 306 103C306 105.209 304.209 107 302 107H267C264.791 107 263 105.209 263 103C263 100.791 264.791 99 267 99H302Z",
    fill: "#317AE2"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M249 85C251.209 85 253 86.791 253 89C253 91.209 251.209 93 249 93H214C211.791 93 210 91.209 210 89C210 86.791 211.791 85 214 85H249Z",
    fill: "#DCDDDD"
  }))), _path15 || (_path15 = /*#__PURE__*/React.createElement("path", {
    d: "M279.512 200.106L283.494 208.645L278.962 210.758C278.461 210.991 277.866 210.775 277.633 210.274L274.032 202.552L270.435 206.125C270.043 206.514 269.41 206.512 269.021 206.12C268.837 205.935 268.733 205.686 268.73 205.425L268.54 185.829C268.535 185.277 268.978 184.825 269.53 184.82C269.772 184.818 270.006 184.903 270.19 185.06L285.11 197.828C285.53 198.187 285.579 198.818 285.22 199.238C285.053 199.433 284.818 199.556 284.563 199.582L279.512 200.106Z",
    fill: "white"
  })), _path16 || (_path16 = /*#__PURE__*/React.createElement("path", {
    d: "M279.512 200.106L283.494 208.645L278.962 210.758C278.461 210.991 277.866 210.775 277.633 210.274L274.032 202.552L270.435 206.125C270.043 206.514 269.41 206.512 269.021 206.12C268.837 205.935 268.733 205.686 268.73 205.425L268.54 185.829C268.535 185.277 268.978 184.825 269.53 184.82C269.772 184.818 270.006 184.903 270.19 185.06L285.11 197.828C285.53 198.187 285.579 198.818 285.22 199.238C285.053 199.433 284.818 199.556 284.563 199.582L279.512 200.106Z",
    stroke: "#26292C",
    strokeWidth: 2.5,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path17 || (_path17 = /*#__PURE__*/React.createElement("path", {
    d: "M59.488 50.8999V54.7999M59.488 59.9999V63.8999M52.988 57.3999H56.888M62.088 57.3999H65.988",
    stroke: "#CBCCCD",
    strokeWidth: 2.5,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path18 || (_path18 = /*#__PURE__*/React.createElement("path", {
    d: "M6.75 193C9.511 193 11.75 195.239 11.75 198C11.75 200.761 9.511 203 6.75 203C3.989 203 1.75 200.761 1.75 198C1.75 195.239 3.989 193 6.75 193Z",
    stroke: "#DCDDDD",
    strokeWidth: 2.5,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path19 || (_path19 = /*#__PURE__*/React.createElement("path", {
    d: "M413.715 119.194C423.713 116.324 434.752 120.487 440.188 129.902C446.593 140.997 442.793 155.183 431.698 161.588C420.603 167.993 406.417 164.193 400.012 153.098C394.576 143.683 396.49 132.041 403.975 124.818",
    fill: "white"
  })), /*#__PURE__*/React.createElement("mask", {
    id: "mask2_360_148",
    style: {
      maskType: "alpha"
    },
    maskUnits: "userSpaceOnUse",
    x: 396,
    y: 118,
    width: 48,
    height: 47
  }, _path20 || (_path20 = /*#__PURE__*/React.createElement("path", {
    d: "M413.715 119.194C423.713 116.324 434.752 120.487 440.188 129.902C446.593 140.997 442.793 155.183 431.698 161.588C420.603 167.993 406.417 164.193 400.012 153.098C394.576 143.683 396.49 132.041 403.975 124.818",
    fill: "white"
  }))), _g3 || (_g3 = /*#__PURE__*/React.createElement("g", {
    mask: "url(#mask2_360_148)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M401.975 166.15C401.975 156.14 410.09 148.025 420.1 148.025C430.11 148.025 438.225 156.14 438.225 166.15",
    fill: "#317AE2"
  }))), /*#__PURE__*/React.createElement("mask", {
    id: "mask3_360_148",
    style: {
      maskType: "alpha"
    },
    maskUnits: "userSpaceOnUse",
    x: 396,
    y: 118,
    width: 48,
    height: 47
  }, _path21 || (_path21 = /*#__PURE__*/React.createElement("path", {
    d: "M413.715 119.194C423.713 116.324 434.752 120.487 440.188 129.902C446.593 140.997 442.793 155.183 431.698 161.588C420.603 167.993 406.417 164.193 400.012 153.098C394.576 143.683 396.49 132.041 403.975 124.818",
    fill: "white"
  }))), _g4 || (_g4 = /*#__PURE__*/React.createElement("g", {
    mask: "url(#mask3_360_148)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M428.075 134.975C428.075 139.379 424.506 142.95 420.1 142.95C415.696 142.95 412.125 139.379 412.125 134.975C412.125 130.571 415.696 127 420.1 127C424.506 127 428.075 130.571 428.075 134.975Z",
    fill: "#317AE2"
  }))), _path22 || (_path22 = /*#__PURE__*/React.createElement("path", {
    d: "M413.715 119.194C423.713 116.324 434.752 120.487 440.188 129.902C446.593 140.997 442.793 155.183 431.698 161.588C420.603 167.993 406.417 164.193 400.012 153.098C394.576 143.683 396.49 132.041 403.975 124.818",
    stroke: "#26292C",
    strokeWidth: 2.5,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path23 || (_path23 = /*#__PURE__*/React.createElement("path", {
    d: "M400.978 42.9099C412.508 45.9859 421 56.5009 421 68.9999C421 68.9999 421 84.9239 421 95.5899",
    stroke: "#747678",
    strokeWidth: 2.5,
    strokeLinecap: "round",
    strokeLinejoin: "round",
    strokeDasharray: "6 8"
  })), _path24 || (_path24 = /*#__PURE__*/React.createElement("path", {
    d: "M411.757 100.857L420.757 109.857L429.757 100.857",
    stroke: "#747678",
    strokeWidth: 2.5,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), /*#__PURE__*/React.createElement("mask", {
    id: "mask4_360_148",
    style: {
      maskType: "luminance"
    },
    maskUnits: "userSpaceOnUse",
    x: 117,
    y: 14,
    width: 53,
    height: 62
  }, _path25 || (_path25 = /*#__PURE__*/React.createElement("path", {
    d: "M117.03 14.9729H169.03V75.7729H117.03V14.9729Z",
    fill: "white"
  }))), /*#__PURE__*/React.createElement("g", {
    mask: "url(#mask4_360_148)"
  }, _path26 || (_path26 = /*#__PURE__*/React.createElement("path", {
    d: "M142.39 17.553C155.368 17.553 165.89 28.0746 165.89 41.053C165.89 47.5354 163.265 53.405 159.02 57.6562L159.021 66.5818C159.021 66.7386 158.959 66.889 158.847 67.0002C158.617 67.2322 158.241 67.233 158.01 67.0018L153.013 62.0202C149.823 63.6402 146.213 64.553 142.39 64.553C129.411 64.553 118.89 54.0314 118.89 41.053C118.89 28.0746 129.411 17.553 142.39 17.553Z",
    fill: "#FFCC00"
  })), /*#__PURE__*/React.createElement("mask", {
    id: "mask5_360_148",
    style: {
      maskType: "luminance"
    },
    maskUnits: "userSpaceOnUse",
    x: 123,
    y: 32,
    width: 39,
    height: 18
  }, _path27 || (_path27 = /*#__PURE__*/React.createElement("path", {
    d: "M123.27 32.373H161.91V49.733H123.27V32.373Z",
    fill: "white"
  }))), _g5 || (_g5 = /*#__PURE__*/React.createElement("g", {
    mask: "url(#mask5_360_148)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M155.235 40.9898C155.235 42.2476 154.215 43.2674 152.958 43.2674C151.7 43.2674 150.681 42.2476 150.681 40.9898C150.681 39.7321 151.7 38.7129 152.958 38.7129C154.215 38.7129 155.235 39.7321 155.235 40.9898Z",
    stroke: "white",
    strokeWidth: 1.12
  }), /*#__PURE__*/React.createElement("path", {
    d: "M155.235 40.9898C155.235 42.2476 154.215 43.2674 152.958 43.2674C151.7 43.2674 150.681 42.2476 150.681 40.9898C150.681 39.7321 151.7 38.7129 152.958 38.7129C154.215 38.7129 155.235 39.7321 155.235 40.9898Z",
    fill: "white"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M144.654 40.9898C144.654 42.2476 143.635 43.2674 142.377 43.2674C141.119 43.2674 140.1 42.2476 140.1 40.9898C140.1 39.7321 141.119 38.7129 142.377 38.7129C143.635 38.7129 144.654 39.7321 144.654 40.9898Z",
    stroke: "white",
    strokeWidth: 1.12
  }), /*#__PURE__*/React.createElement("path", {
    d: "M144.654 40.9898C144.654 42.2476 143.635 43.2674 142.377 43.2674C141.119 43.2674 140.1 42.2476 140.1 40.9898C140.1 39.7321 141.119 38.7129 142.377 38.7129C143.635 38.7129 144.654 39.7321 144.654 40.9898Z",
    fill: "white"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M134.073 40.9898C134.073 42.2476 133.054 43.2674 131.796 43.2674C130.539 43.2674 129.519 42.2476 129.519 40.9898C129.519 39.7321 130.539 38.7129 131.796 38.7129C133.054 38.7129 134.073 39.7321 134.073 40.9898Z",
    stroke: "white",
    strokeWidth: 1.12
  }), /*#__PURE__*/React.createElement("path", {
    d: "M134.073 40.9898C134.073 42.2476 133.054 43.2674 131.796 43.2674C130.539 43.2674 129.519 42.2476 129.519 40.9898C129.519 39.7321 130.539 38.7129 131.796 38.7129C133.054 38.7129 134.073 39.7321 134.073 40.9898Z",
    fill: "white"
  })))), _path28 || (_path28 = /*#__PURE__*/React.createElement("path", {
    d: "M322.785 135C345.547 135 364 116.547 364 93.7849V80.9089",
    stroke: "#747678",
    strokeWidth: 2.5,
    strokeLinecap: "round",
    strokeLinejoin: "round",
    strokeDasharray: "6 8"
  })), /*#__PURE__*/React.createElement("mask", {
    id: "mask6_360_148",
    style: {
      maskType: "luminance"
    },
    maskUnits: "userSpaceOnUse",
    x: 314,
    y: -3,
    width: 100,
    height: 101
  }, _path29 || (_path29 = /*#__PURE__*/React.createElement("path", {
    d: "M314 -2.68311H414V97.3169H314V-2.68311Z",
    fill: "white"
  }))), _g6 || (_g6 = /*#__PURE__*/React.createElement("g", {
    mask: "url(#mask6_360_148)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M390.373 17.25L395.997 11.626",
    stroke: "#3079E1",
    strokeWidth: 2.5,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M385.282 13.231L385.549 8.677",
    stroke: "#3079E1",
    strokeWidth: 2.5,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M394.66 22.609L399.214 22.342",
    stroke: "#3079E1",
    strokeWidth: 2.5,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M376.175 22.4551C375.765 22.2351 375.345 22.0351 374.915 21.8351C371.585 20.3251 367.895 19.4851 363.995 19.4851C349.395 19.4851 337.565 31.3251 337.565 45.9251C337.565 53.2151 340.515 59.8251 345.285 64.6051L345.295 74.3651C345.295 74.5751 345.375 74.7651 345.515 74.9151C345.795 75.1951 346.235 75.2251 346.535 74.9951L346.625 74.9151L352.045 69.5151C355.635 71.3351 359.695 72.3651 363.995 72.3651C378.605 72.3651 390.435 60.5251 390.435 45.9251C390.435 38.9651 387.745 32.6351 383.355 27.9151",
    fill: "white"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M376.175 22.4551C375.765 22.2351 375.345 22.0351 374.915 21.8351C371.585 20.3251 367.895 19.4851 363.995 19.4851C349.395 19.4851 337.565 31.3251 337.565 45.9251C337.565 53.2151 340.515 59.8251 345.285 64.6051L345.295 74.3651C345.295 74.5751 345.375 74.7651 345.515 74.9151C345.795 75.1951 346.235 75.2251 346.535 74.9951L346.625 74.9151L352.045 69.5151C355.635 71.3351 359.695 72.3651 363.995 72.3651C378.605 72.3651 390.435 60.5251 390.435 45.9251C390.435 38.9651 387.745 32.6351 383.355 27.9151",
    stroke: "#25292C",
    strokeWidth: 2.5,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M368.375 31.562L352.708 45.269H372.292L356.625 58.978",
    stroke: "#3079E1",
    strokeWidth: 2.5,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgConfigureLivechat);
export default __webpack_public_path__ + "static/media/Configure_livechat.9622a66f8d5480800b3c411cec952745.svg";
export { ForwardRef as ReactComponent };